/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPregnant = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14 6c0 1.46-.783 2.739-1.953 3.437a5.018 5.018 0 0 1 2.552 2.599A5 5 0 0 1 14 22v-2a3 3 0 1 0 0-6h-1a3 3 0 1 0-6 0v8H5v-8a5.001 5.001 0 0 1 2.953-4.563A4 4 0 1 1 14 6zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0z" />
        <path d="M14.075 16h-.001l-.04.001h-.002a.89.89 0 0 0-.532.214.882.882 0 0 0-1.23.074 1.037 1.037 0 0 0 0 1.398L13.5 19l1.23-1.313c.172-.185.27-.437.27-.7s-.098-.513-.27-.698a.895.895 0 0 0-.655-.289z" />
      </g>
    </g>
  </Icon>
);
export { SvgPregnant as Pregnant };
